var noUpdate = false;

var vProductList = new Vue({
    el: '#v-product-list',
    data: {
        filter: {
            productCategory: [],
            productType: [],
            productTypeSize: [],
            color: [],
            designer: [],
            displayedDesigner: [],
            popularDesigner: [],
            condition: [],
            price: {
                min: 100000,
                max: 950000000
            }
        },
        filterToggle: {
            productCategory: true,
            productType: true,
            productTypeSize: {
                bags: false,
                shoes: false,
                accessories: false,
                clothing: false
            },
            color: true,
            designer: false,
            price: false,
            condition: false,
            gender: true,
            delivery: true,
        },
        selected: {
            category: null,
            productCategory: null,
            productType: null,
            productTypes: [],
            productTypeDetails: [],
            productTypeSizes: [],
            colors: [],
            designers: [],
            conditions: [],
            price: {
                min: null,
                max: null
            },
            genders: [],
            sale: null,
            saleStart: null,
            saleStartBefore: null,
            delivery: [],
            notSold: false
        },
        selectedBackup: {},
        search: {
            designer: '',
            lastDesigner: ''
        },
        sortBy: 'new',
        query: '',
        currentPage: 1,
        perPage: 48,
        perPageOptions: [48, 96],
        isChangingPage: false,
        pagination: {},
        products: [],
        isLoading: false,
        filterChangedCounter: 0,
        countByDesigner: [],
        countByDesignerKey: null,
        firstCall: true,
        wholeMode: false,
        cache: {
            max: 5,
            key: null,
            data: []
        },
        isNeedNextPage: true
    },
    computed: {
        selectedProductTypeName: function () {
            for (var i = 0; i < this.filter.productType.length; i++) {
                var productType = this.filter.productType[i];
                if (productType.code == this.selected.productType) {
                    return productType.name;
                }
            }

            return null;
        },
        productTypeNoFilter: function () {
            if (this.selected.productType == null || this.selected.productType.length == 0) {
                return true;
            }

            return false;
        },
        isLastPage: function () {
            return this.currentPage == this.pagination.last_page;
        },
    },
    watch: {
        'selected.notSold': function () {
            this.filterChanged();
        },
        'selected.category': function () {
            this.filterChanged();
        },
        'selected.productCategory': function () {
            this.filterChanged();
        },
        'selected.productType': function (val, oldVal) {
            if (val != oldVal && oldVal != null && oldVal != '') {
                this.selected.productTypeDetails = [];
            }
            this.filterChanged();
        },
        'selected.productTypeDetails': function () {
            this.filterChanged();
        },
        'selected.productTypeSizes': function () {
            this.filterChanged();
        },
        'selected.colors': function () {
            this.filterChanged();
        },
        'selected.designers': function () {
            this.filterChanged();
        },
        'selected.conditions': function () {
            this.filterChanged();
        },
        sortBy: function () {
            this.filterChanged();
        },
        currentPage: function () {
            this.isChangingPage = true;
            this.filterChanged();
        },
        perPage: function () {
            this.filterChanged();
        },
        'filterToggle.designer': function (value) {
            if (value) {
                this.applyScrollPane();
            }
        },
        'filter.price.min': function (value) {
            $('.slider').slider('values', 0, value);
        },
        'filter.price.max': function (value) {
            $('.slider').slider('values', 1, value);
        },
        'search.designer': function (keyword) {
            this.search.lastDesigner = keyword;

            var _self = this;
            setTimeout(function () {
                if (keyword === _self.search.lastDesigner) {
                    _self.updateDisplayedDesigner(keyword);
                }
            }, 500);
        },
        'selected.genders': function () {
            this.filterChanged();
        },
        'selected.delivery': function () {
            this.filterChanged();
        },
        products: function (val) {
            var productNotFoundBox = document.querySelector('.productNotFoundBox');

            if ( ! val.length && ! this.isLoading) {
                productNotFoundBox.classList.remove('hide');
            }
        },
        isLoading: function (val) {
            var productNotFoundBox = document.querySelector('.productNotFoundBox');

            if (val === false && ! this.products.length) {
                productNotFoundBox.classList.remove('hide');
            }
        }
    },
    methods: {
        updateDisplayedDesigner: function (keywordFilter) {
            var designers = [];
            var isDesignerKeyword = function (keywords) {
                for (var i = 0; i < keywords.length; i++) {
                    if (keywords[i].indexOf(keywordFilter.toLowerCase()) != -1) {
                        return true;
                    }
                }
                return false;
            };
            this.filter.designer.forEach(function (designer) {
                if (keywordFilter == '' || designer.name.toLowerCase().indexOf(keywordFilter.toLowerCase()) != -1 || this.isDesignerChecked(designer.code)) {
                    designers.push(designer);
                }
                // if (((keywordFilter == '' || designer.name.toLowerCase().indexOf(keywordFilter.toLowerCase()) != -1 || isDesignerKeyword(designer.keywords)) && typeof this.countByDesigner[parseInt(designer.id)] != 'undefined') || this.isDesignerChecked(designer.code)) {
                //     designers.push(designer);
                // }
            }.bind(this));

            this.filter.displayedDesigner = designers;

            this.applyScrollPane();
        },
        setSelectedNotSold: function () {
            this.selected.notSold = !this.selected.notSold;
        },
        setSelectedProductCategory: function (productCategoryCode) {
            if (productCategoryCode) {
                this.selected.productCategory = productCategoryCode;
                this.filterToggle.productCategory = true;
            }
        },
        setSelectedProductType: function (productTypeCode) {
            if (productTypeCode) {
                this.selected.productType = productTypeCode;
                this.filterToggle.productType = true;
            }
        },
        setSelectedProductTypes: function (productTypeIds) {
            if (productTypeIds) {
                this.selected.productTypes = productTypeIds;
            }
        },
        setSelectedProductTypeSizes: function (productTypeSizeCodes) {
            if (productTypeSizeCodes.length > 0) {
                this.filter.productTypeSize.forEach(function (productType) {
                    productType.sizes.forEach(function (size) {
                        if (productTypeSizeCodes.indexOf(size.code + '') !== -1) {
                            this.filterToggle.productTypeSize[productType.code] = true;
                        }
                    }.bind(this));
                }.bind(this));
                this.selected.productTypeSizes = productTypeSizeCodes;
            }
        },
        setSelectedColors: function (colorCodes) {
            if (colorCodes.length > 0) {
                this.filter.color.forEach(function (color) {
                    if (colorCodes.indexOf(color.code + '') !== -1) {
                        this.filterToggle.color = true;
                    }
                }.bind(this));
                this.selected.colors = colorCodes;
            }
        },
        setSelectedDesigners: function (designerCodes) {
            if (designerCodes.length > 0) {
                this.filter.designer.forEach(function (designer) {
                    if (designerCodes.indexOf(designer.code + '') !== -1) {
                        this.filterToggle.designer = true;
                    }
                }.bind(this));
                this.selected.designers = designerCodes;
            }
        },
        setSelectedConditions: function (conditionCodes) {
            if (conditionCodes.length > 0) {
                this.filter.condition.forEach(function (condition) {
                    if (conditionCodes.indexOf(condition.code + '') !== -1) {
                        this.filterToggle.condition = true;
                    }
                }.bind(this));
                this.selected.conditions = conditionCodes;
            }
        },
        setSelectedPrice: function () {
            this.filterToggle.price = true;
            this.selected.price.min = this.filter.price.min;
            this.selected.price.max = this.filter.price.max;
            this.filterChanged();
        },
        isDesignerChecked: function (designerCode) {
            if (this.selected.designers.indexOf(designerCode) == -1) {
                return false;
            }

            return true;
        },
        setSelectedGenders: function (genderCodes) {
            this.selected.genders = genderCodes;
        },
        setSelectedDelivery: function (code) {
            this.selected.delivery = code;
        },
        applyScrollPane: function () {
            $('.scroll-pane').jScrollPane({autoReinitialise: true});
        },
        setPage: function (page) {
            if (page < 1) {
                page = 1;
            } else if (page > this.pagination.last_page) {
                page = this.pagination.last_page;
            }

            this.currentPage = page;

            var expectedTop = $('#title-container').offset().top - 100;
            if ($(window).scrollTop() > expectedTop) {
                $('html, body').animate({scrollTop: expectedTop}, 'fast');
            }

            return false;
        },
        setPerPage: function (perPage) {
            if (this.perPageOptions.indexOf(perPage) !== -1) {
                this.perPage = perPage;
                this.filterChanged();
            }
        },
        isRenderPage: function (page) {
            var min = (this.currentPage - 3);
            var extendLast = 0;
            if (min < 1) {
                //extendLast = (min * -1) + 1;
                min = 1;
            }

            var max = (this.currentPage + 3) + extendLast;
            var extendFirst = 0;
            if (max > this.pagination.last_page) {
                //extendFirst = (max - this.pagination.last_page);
                max = this.pagination.last_page;
            }

            min -= extendFirst;
            if (min < 1) {
                min = 1;
            }

            if (page == 1 || page == 2 || page == this.pagination.last_page - 1 || page == this.pagination.last_page) {
                return true;
            } else if (page >= min && page <= max) {
                return true;
            }

            return false;
        },
        isNextHasDot: function (page) {
            if (page < this.pagination.last_page) {
                if (!this.isRenderPage(page + 1)) {
                    return true;
                }
            }

            return false;
        },
        filterChanged: function () {
            if (!this.wholeMode) {
                this.filterChangedCounter++;

                var self = this;
                setTimeout(function () {
                    self.filterChangedCounter--;
                    if (self.filterChangedCounter == 0) {
                        if (noUpdate) {
                            noUpdate = false;
                        } else {
                            if (self.firstCall) {
                                self.firstCall = false;
                            } else {
                                self.getDataWithCurrentParameters();
                            }
                        }
                    }
                }, 200);
            }
        },
        getUrlPath: function () {
            var urlPath = baseUrlPath;

            if (this.selected.category || this.selected.productType || this.selected.productCategory) {
                if (this.selected.category !== null && this.selected.category.indexOf('closet') === -1) {
                    urlPath += '/' + (this.selected.category ? this.selected.category : 'all');
                }
            }

            if (this.selected.productType || this.selected.productCategory) {
                urlPath += '/' + (this.selected.productType ? this.selected.productType : 'all');
            }

            if (this.selected.productCategory) {
                urlPath += '/' + this.selected.productCategory;
            }

            var queryParameters = [];
            if (this.query) {
                queryParameters.push('q=' + this.query.replace(/ /g, '+'));
            }
            if (this.selected.productTypes.length) {
                queryParameters.push('types=' + this.selected.productTypes);
            }
            if (this.selected.productTypeDetails.length) {
                queryParameters.push('type=' + this.selected.productTypeDetails);
            }
            if (this.selected.productTypeSizes.length) {
                queryParameters.push('size=' + this.selected.productTypeSizes);
            }
            if (this.selected.colors.length) {
                queryParameters.push('color=' + this.selected.colors);
            }
            if (this.selected.designers.length) {
                queryParameters.push('designer=' + this.selected.designers);
            }
            if (this.selected.conditions.length) {
                queryParameters.push('condition=' + this.selected.conditions);
            }
            if (this.selected.sale) {
                queryParameters.push('sale=' + this.selected.sale);
            }
            if (this.selected.saleStart) {
                queryParameters.push('sale_start=' + this.selected.saleStart);
            }
            if (this.selected.saleStartBefore) {
                queryParameters.push('sale_start_before=' + this.selected.saleStartBefore);
            }
            if (this.currentPage > 1) {
                queryParameters.push('page=' + this.currentPage);
            }
            if (this.perPage != 48) {
                queryParameters.push('show=' + this.perPage);
            }
            if (typeof this.sortBy !== 'undefined' && this.sortBy !== null && this.sortBy !== 'new') {
                queryParameters.push('sort=' + this.sortBy);
            }
            if (this.selected.price.min !== null) {
                queryParameters.push('min=' + this.selected.price.min);
            }
            if (this.selected.price.max !== null) {
                queryParameters.push('max=' + this.selected.price.max);
            }
            if (this.selected.genders.length) {
                queryParameters.push('gender=' + this.selected.genders);
            }
            if (this.selected.delivery.length) {
                queryParameters.push('delivery=' + this.selected.delivery);
            }

            if (queryParameters.length) {
                urlPath += '?' + queryParameters.join('&');
            }

            return urlPath;
        },
        generateParameters: function (page) {
            if (typeof page === 'undefined') {
                page = this.currentPage;
            }

            return {
                q: this.query,
                cat: this.selected.category,
                category: this.selected.productCategory,
                type: this.selected.productType,
                types: this.selected.productTypes,
                dets: this.selected.productTypeDetails,
                sizes: this.selected.productTypeSizes,
                colors: this.selected.colors,
                designers: this.selected.designers,
                conditions: this.selected.conditions,
                sale: this.selected.sale,
                sale_start: this.selected.saleStart,
                sale_start_before: this.selected.saleStartBefore,
                page: page,
                show: this.perPage,
                sort: this.sortBy,
                min: this.selected.price.min,
                max: this.selected.price.max,
                gender: this.selected.genders,
                delivery: this.selected.delivery,
                key: this.countByDesignerKey,
                not_sold: this.selected.notSold
            };
        },
        getKeyFromParameters: function (parameters) {
            var parametersClone = JSON.parse(JSON.stringify(parameters));
            parametersClone.page = null;
            parametersClone.key = null;
            return JSON.stringify(parametersClone);
        },
        getDataWithCurrentParameters: function () {
            var parameters = this.generateParameters();
            this.getData(parameters);
        },
        getData: function (parameters, isBackground) {
            if (typeof isBackground === 'undefined') {
                isBackground = false;
            }

            var cacheData = null;
            if (!isBackground) {
                cacheData = this.getCache(this.getKeyFromParameters(parameters), parameters.page, parameters.perPage);
            }

            if (cacheData) {
                this.applyData(cacheData);
            } else {
                var self = this;

                if (!isBackground) {
                    this.products = [];
                    this.isLoading = true;
                }
                this.$http.post(getProductUrl, parameters).then(function (success) {
                    if (success.ok) {
                        var data = success.data;

                        if (!isBackground) {
                            self.applyDataAndSaveCache(data);
                        } else {
                            self.saveCache(self.getKeyFromParameters(parameters), parameters.page, parameters.perPage, data);
                        }
                    } else {
                        self.isLoading = false;
                        self.isChangingPage = false;
                    }
                }, function (error) {
                    self.isLoading = false;
                    self.isChangingPage = false;
                    console.log('Failed to get products! Please refresh page and try again.');
                });
            }
        },
        applyDataAndSaveCache: function (data, notRemoveQueryString) {
            if (this.applyData(data, notRemoveQueryString)) {
                var parameters = this.generateParameters(this.currentPage);
                this.saveCache(this.getKeyFromParameters(parameters), parameters.page, parameters.perPage, data);
            }
        },
        applyData: function (data, notRemoveQueryString) {
            if (typeof notRemoveQueryString == 'undefined') {
                notRemoveQueryString = false;
            }

            var self = this;

            self.pagination = data.meta;
            self.products = data.products;
            self.perPage = data.meta.per_page;

            if (self.currentPage > data.meta.last_page) {
                self.currentPage = data.meta.last_page;
                return false;
            } else {

                if (typeof data.count_by_designer !== 'undefined' && data.count_by_designer && typeof data.count_by_designer.list !== 'undefined') {
                    self.countByDesigner = data.count_by_designer.list;
                    self.countByDesignerKey = data.count_by_designer.key;
                    self.updateDisplayedDesigner(self.query);
                }

                self.isLoading = false;
                self.isChangingPage = false;

                if (notRemoveQueryString) {
                    window.history.pushState({
                        'data': self.$data
                    }, '');
                } else {
                    window.history.pushState({
                        'data': self.$data
                    }, '', this.getUrlPath());
                }

                setTimeout(function () {
                    applyConditionInfo();
                    $(window).resize();
                    self.isNeedNextPage = true;
                }, 500);

                return true;
            }
        },
        addToBag: function (productCode) {
            $('#add-to-bag-product').val(productCode);
            $('#add-to-bag-form').submit();
        },
        activateWholeMode: function () {
            this.saveSelectedFilter();
            this.wholeMode = true;
        },
        inactivateWholeMode: function () {
            this.wholeMode = false;
        },
        saveSelectedFilter: function () {
            this.selectedBackup = JSON.parse(JSON.stringify(this.selected));
        },
        rollbackSelectedFilter: function () {
            this.selected = this.selectedBackup;
        },
        resetFilterToggle: function () {
            this.filterToggle.designer = false;
        },
        clickCategory: function (code) {
            if (this.selected.productCategory == code) {
                this.selected.productCategory = null;
            } else {
                this.selected.productCategory = code;
            }
        },
        clickType: function (code) {
            if (this.selected.productType == code) {
                this.selected.productType = null;
            } else {
                this.selected.productType = code;
            }
        },
        clickTypeDetail: function (code) {
            var index = this.selected.productTypeDetails.indexOf(code);
            if (index !== -1) {
                this.selected.productTypeDetails.splice(index, 1);
            } else {
                this.selected.productTypeDetails.push(code);
            }
        },
        clickSize: function (code) {
            var index = this.selected.productTypeSizes.indexOf(code);
            if (index !== -1) {
                this.selected.productTypeSizes.splice(index, 1);
            } else {
                this.selected.productTypeSizes.push(code);
            }
        },
        clickColor: function (code) {
            var index = this.selected.colors.indexOf(code);
            if (index !== -1) {
                this.selected.colors.splice(index, 1);
            } else {
                this.selected.colors.push(code);
            }
        },
        clickCondition: function (code) {
            var index = this.selected.conditions.indexOf(code);
            if (index !== -1) {
                this.selected.conditions.splice(index, 1);
            } else {
                this.selected.conditions.push(code);
            }
        },
        clickDesigner: function (code) {
            var index = this.selected.designers.indexOf(code);
            if (index !== -1) {
                this.selected.designers.splice(index, 1);
            } else {
                this.selected.designers.push(code);
            }
        },
        clearDesigner: function () {
            this.selected.designers = [];
        },
        clickGender: function (code) {
            var index = this.selected.genders.indexOf(code);
            if (index !== -1) {
                this.selected.genders.splice(index, 1);
            } else {
                this.selected.genders.push(code);
            }
        },
        clickDelivery: function (code) {
            var index = this.selected.delivery.indexOf(code);
            if (index !== -1) {
                this.selected.delivery.splice(index, 1);
            } else {
                this.selected.delivery.push(code);
            }
        },
        requestRestock: function (productCode, event) {
            if (typeof event != 'undefined') {
                var button = $(event.target);
                var currentWidth = button.css('width');
                button.attr('disabled', 'disabled');
                button.html('&nbsp;');
                button.css('background', '#fff url(/images/loading.gif) center no-repeat');
                button.css('width', currentWidth);
            }

            this.doWatch(productCode, true, function (success) {
                if (typeof event != 'undefined') {
                    var button = $(event.target);
                    button.removeAttr('disabled');
                    button.css('background', '#fff');
                    button.css('color', '#a37b2c');
                    button.html('Requested');
                }
            });
        },
        like: function (product, event) {
            var productCode = product.code;
            if (typeof event != 'undefined') {
                var button = $(event.target);
                button.attr('disabled', 'disabled');
                button.addClass('loading');
            }

            this.doWatch(productCode, !product.is_watched, function (success) {
                if (typeof event != 'undefined') {
                    var button = $(event.target);
                    button.removeAttr('disabled');
                    button.removeClass('loading');
                }

                product.is_watched = !product.is_watched;
            });
        },
        doWatch: function (productCode, is, postWatch) {
            this.$http.post(restockUrl, {
                code: productCode,
                watch: is
            }).then(function (success) {
                postWatch(success);
            }, function (error) {
                alert(error.data.error.message);
            });
        },
        prepareNextPage: function () {
            if (this.currentPage < this.pagination.last_page) {
                var parameters = this.generateParameters(this.currentPage + 1);

                this.getData(parameters, true);
            }
        },
        saveCache: function (key, page, perPage, result) {
            if (this.cache.key !== key) {
                this.cache.key = key;
                this.cache.data = [];
            } else {
                if (this.cache.data.length >= this.cache.max) {
                    this.cache.data.shift();
                }
            }

            this.cache.data.push({
                page: page,
                perPage: perPage,
                result: result
            });
        },
        getCache: function (key, page, perPage) {
            if (this.cache.key === key) {
                for (var i = this.cache.data.length - 1; i >= 0; i--) {
                    var cacheData = this.cache.data[i];
                    if (cacheData.page === page && cacheData.perPage === perPage) {
                        return cacheData.result;
                    }
                }
            }

            return null;
        }
    },
    //filters: {
    //    searchDesigner: function (designers, searchKey) {
    //        var filteredDesigners = [];
    //        designers.forEach(function (designer) {
    //            if (searchKey == '' || this.isDesignerChecked(designer.code) || designer.name.toLowerCase().indexOf(searchKey.toLowerCase()) != -1) {
    //                filteredDesigners.push(designer);
    //            }
    //        }.bind(this));
    //
    //        this.applyScrollPane();
    //
    //        return filteredDesigners;
    //    }
    //},
    ready: function () {
        var _self = this;
        $('.slider').slider({
            range: true,
            min: defaultMinPriceFilter,
            max: defaultMaxPriceFilter,
            step: defaultStepPriceFilter,
            values: [_self.filter.price.min, _self.filter.price.max],
            slide: function (event, ui) {
                _self.filter.price.min = ui.values[0];
                _self.filter.price.max = ui.values[1];
            }
        });

        if ($(window).width() > 959) {
            this.filterToggle.designer = true;
        }

        $(window).scroll(function () {
            if (_self.isNeedNextPage && $(window).scrollTop() > $('body').height() / 2.5) {
                _self.isNeedNextPage = false;
                _self.prepareNextPage();
            }
        });
    }

});

window.onpopstate = function (e) {
    if (e.state) {
        noUpdate = true;
        vProductList.$data = e.state.data;
    }
};

function holdExpireTicker() {
    $('.holdOn').each(function (index, hold) {
        var ticker = $(hold).find('span');
        var holdExpiredAt = parseInt(ticker.data('expired-at'));
        var duration = holdExpiredAt - currentTimestamp;

        if (duration < 0) {
            ticker.html('00:00:00');
        } else {
            var hour = Math.floor(duration / 3600);
            var minute = Math.floor((duration - (hour * 3600)) / 60);
            var second = duration - (hour * 3600) - (minute * 60);

            ticker.html((hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute + ':' + (second < 10 ? '0' : '') + second);
        }
    });

    currentTimestamp++;

    setTimeout(holdExpireTicker, 1000);
}

holdExpireTicker();

if ($('#topDesignerSlider').length > 0) {
    $("#topDesignerSlider").owlCarousel({
        items: 1,
        autoWidth: true,
        margin: 10,
        pagination: false
    });
}

$('.filterBtn').click(function () {
    //$('.sideMenuBox, .submitFilterBox').animate({ left: 0 });
    vProductList.activateWholeMode();
    $('.sideMenuBox, .submitFilterBox').show();
    $('body, html').css('overflow', 'hidden');
    $('.wrapper').addClass('hiddenParent');
    $('.sideMenuBox').addClass('showedChild');
    $('.zopim').hide();
    return false;
});
$('.closeFilterButton').click(function () {
    //$('.sideMenuBox, .submitFilterBox').animate({ left: -9999 });
    vProductList.rollbackSelectedFilter();
    setTimeout(function () {
        vProductList.inactivateWholeMode();
    }, 500);
    vProductList.resetFilterToggle();
    $('.sideMenuBox, .submitFilterBox').hide();
    $('body, html').css('overflow', 'visible');
    $('.wrapper').removeClass('hiddenParent');
    $('.sideMenuBox').removeClass('showedChild');
    $('.zopim').show();
    return false;
});
$('.submitFilterButton').click(function () {
    //$('.sideMenuBox, .submitFilterBox').animate({ left: -9999 });
    vProductList.inactivateWholeMode();
    vProductList.filterChanged();
    vProductList.resetFilterToggle();
    $('.sideMenuBox, .submitFilterBox').hide();
    $('body, html').css('overflow', 'visible');
    $('.wrapper').removeClass('hiddenParent');
    $('.sideMenuBox').removeClass('showedChild');
    return false;
});

var starRatingOption = {
    initialRating: 0,
    useGradient: false,
    activeColor: '#A47B24',
    strokeColor: '#A47B24',
    strokeWidth: 5,
    starSize: screen.width < 768 ? 12 : 18,
    readOnly: true
}

$(".noRateStar").starRating(Object.assign(starRatingOption, {
    initialRating: 0,
    starSize: screen.width < 768 ? 12 : 14
}));
$(".rateStar.one").starRating(Object.assign(starRatingOption, {initialRating: 1}));
$(".rateStar.one-half").starRating(Object.assign(starRatingOption, {initialRating: 1.5}));
$(".rateStar.two").starRating(Object.assign(starRatingOption, {initialRating: 2}));
$(".rateStar.two-half").starRating(Object.assign(starRatingOption, {initialRating: 2.5}));
$(".rateStar.three").starRating(Object.assign(starRatingOption, {initialRating: 3}));
$(".rateStar.three-half").starRating(Object.assign(starRatingOption, {initialRating: 3.5}));
$(".rateStar.four").starRating(Object.assign(starRatingOption, {initialRating: 4}));
$(".rateStar.four-half").starRating(Object.assign(starRatingOption, {initialRating: 4.5}));
$(".rateStar.five").starRating(Object.assign(starRatingOption, {initialRating: 5}));